// Fetch availability
export const FETCH_CHAKRA_AVAILABILITY_REQUEST = 'FETCH_CHAKRA_AVAILABILITY_REQUEST';
export const fetchChakraAvailabilityRequest = () =>
  ({ type: FETCH_CHAKRA_AVAILABILITY_REQUEST });

export const FETCH_CHAKRA_AVAILABILITY_SUCCESS = 'FETCH_CHAKRA_AVAILABILITY_SUCCESS';
export const fetchChakraAvailabilitySuccess = (available) =>
  ({ type: FETCH_CHAKRA_AVAILABILITY_SUCCESS, payload: { available } });

export const FETCH_CHAKRA_AVAILABILITY_FAILURE = 'FETCH_CHAKRA_AVAILABILITY_FAILURE';
export const fetchChakraAvailabilityFailure = (error) =>
  ({ type: FETCH_CHAKRA_AVAILABILITY_FAILURE, payload: error });

// Fetch questionnaire
export const FETCH_CHAKRA_QUESTIONNAIRE_REQUEST = 'FETCH_CHAKRA_QUESTIONNAIRE_REQUEST';
export const fetchChakraQuestionnaireRequest = () =>
  ({ type: FETCH_CHAKRA_QUESTIONNAIRE_REQUEST });

export const FETCH_CHAKRA_QUESTIONNAIRE_SUCCESS = 'FETCH_CHAKRA_QUESTIONNAIRE_SUCCESS';
export const fetchChakraQuestionnaireSuccess = (questions) =>
  ({ type: FETCH_CHAKRA_QUESTIONNAIRE_SUCCESS, payload: { questions } });

export const FETCH_CHAKRA_QUESTIONNAIRE_FAILURE = 'FETCH_CHAKRA_QUESTIONNAIRE_FAILURE';
export const fetchChakraQuestionnaireFailure = (error) =>
  ({ type: FETCH_CHAKRA_QUESTIONNAIRE_FAILURE, payload: error });

// Submit questionnaire
export const SUBMIT_CHAKRA_QUESTIONNAIRE_REQUEST = 'SUBMIT_CHAKRA_QUESTIONNAIRE_REQUEST';
export const submitChakraQuestionnaireRequest = (answers) =>
  ({ type: SUBMIT_CHAKRA_QUESTIONNAIRE_REQUEST, payload: { answers } });

export const SUBMIT_CHAKRA_QUESTIONNAIRE_SUCCESS = 'SUBMIT_CHAKRA_QUESTIONNAIRE_SUCCESS';
export const submitChakraQuestionnaireSuccess = (reading) =>
  ({ type: SUBMIT_CHAKRA_QUESTIONNAIRE_SUCCESS, payload: { reading } });

export const SUBMIT_CHAKRA_QUESTIONNAIRE_FAILURE = 'SUBMIT_CHAKRA_QUESTIONNAIRE_FAILURE';
export const submitChakraQuestionnaireFailure = (error) =>
  ({ type: SUBMIT_CHAKRA_QUESTIONNAIRE_FAILURE, payload: error });

// Set reading like
export const SET_CHAKRA_READING_LIKE_REQUEST = 'SET_CHAKRA_READING_LIKE_REQUEST';
export const setChakraReadingLikeRequest = (reading_id, like) =>
  ({ type: SET_CHAKRA_READING_LIKE_REQUEST, payload: { reading_id, like } });

export const SET_CHAKRA_READING_LIKE_SUCCESS = 'SET_CHAKRA_READING_LIKE_SUCCESS';
export const setChakraReadingLikeSuccess = () =>
  ({ type: SET_CHAKRA_READING_LIKE_SUCCESS });

export const SET_CHAKRA_READING_LIKE_FAILURE = 'SET_CHAKRA_READING_LIKE_FAILURE';
export const setChakraReadingLikeFailure = (error) =>
  ({ type: SET_CHAKRA_READING_LIKE_FAILURE, payload: error });

// Fetch all chakras (catalog)
export const FETCH_ALL_CHAKRAS_REQUEST = 'FETCH_ALL_CHAKRAS_REQUEST';
export const fetchAllChakrasRequest = () =>
  ({ type: FETCH_ALL_CHAKRAS_REQUEST });

export const FETCH_ALL_CHAKRAS_SUCCESS = 'FETCH_ALL_CHAKRAS_SUCCESS';
export const fetchAllChakrasSuccess = (chakras) =>
  ({ type: FETCH_ALL_CHAKRAS_SUCCESS, payload: { chakras } });

export const FETCH_ALL_CHAKRAS_FAILURE = 'FETCH_ALL_CHAKRAS_FAILURE';
export const fetchAllChakrasFailure = (error) =>
  ({ type: FETCH_ALL_CHAKRAS_FAILURE, payload: error });

// Capture lead (email gate)
export const CAPTURE_CHAKRA_LEAD_REQUEST = 'CAPTURE_CHAKRA_LEAD_REQUEST';
export const captureChakraLeadRequest = (email, source, metadata) =>
  ({ type: CAPTURE_CHAKRA_LEAD_REQUEST, payload: { email, source, metadata } });

export const CAPTURE_CHAKRA_LEAD_SUCCESS = 'CAPTURE_CHAKRA_LEAD_SUCCESS';
export const captureChakraLeadSuccess = () =>
  ({ type: CAPTURE_CHAKRA_LEAD_SUCCESS });

export const CAPTURE_CHAKRA_LEAD_FAILURE = 'CAPTURE_CHAKRA_LEAD_FAILURE';
export const captureChakraLeadFailure = (error) =>
  ({ type: CAPTURE_CHAKRA_LEAD_FAILURE, payload: error });

// Reset state
export const RESET_CHAKRAS = 'RESET_CHAKRAS';
export const resetChakras = () =>
  ({ type: RESET_CHAKRAS });
